<script>
import Layout from "@/layouts/main";
import PageHeader from "@/components/page-header";
import { numeric, required } from "vuelidate/lib/validators";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import { VMoney } from "v-money";
import { pagingModel } from "@/models/pagingModel";
import Treeselect from "@riophae/vue-treeselect";
import { menuModel } from "@/models/menuModel";
import vue2Dropzone from "vue2-dropzone";
import { notifyModel } from "@/models/notifyModel";
import { contentModel } from "@/models/contentModel";
import axios from "axios";
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { itemTreeModel } from "@/models/itemTreeModel";
import { contentNoiBoModel } from "../../../models/contentNoiBoModel";
import Vue from "vue";

export default {
  page: {
    title: "Cập nhật tin nội bộ",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout, PageHeader, DatePicker, Treeselect, vueDropzone: vue2Dropzone,
    'ckeditor-nuxt': () => {
      return import('@blowstack/ckeditor-nuxt')
    },
  },
  directives: { money: VMoney },
  data() {
    return {
      data: [],
      title: "Cập nhật tin nội bộ",
      items: [
        {
          text: "Tin nội bộ",
          href: "/tin-noi-bo"
        },
        {
          text: "Cập nhật",
          active: true,
        }
      ],
      currentPage: 1,
      pageOptions: [5, 10, 25, 50, 100],
      sortBy: "age",
      filter: null,
      sortDesc: false,
      isShow: false,
      filterOn: [],
      numberOfElement: 1,
      totalRows: 1,
      perPage: 10,
      stt: 1,
      submitted: false,
      model: menuModel.baseJson(),
      modelContent: contentNoiBoModel.baseJson(),
      itemTree: itemTreeModel.baseJson(),
      pagination: pagingModel.baseJson(),
      treeView: [],
      listParent: [],
      editorConfig: {
        toolbar: {
          items: [
            'heading', '|', 'style',
            'bold',
            'italic',
            'link',
            'bulletedList',
            'numberedList',
            '|',
            'outdent',
            'indent',
            '|',
            'imageUpload',
            'blockQuote',
            'insertTable',
            'mediaEmbed',
            'codeBlock',
            'alignment',
            'ckbox',
            'fontColor',
            'fontBackgroundColor',
            'fontFamily',
            'fontSize',
            'formatPainter',
            'highlight',
            'htmlEmbed',
            'tableOfContents',
            'undo',
            'redo'
          ],
          shouldNotGroupWhenFull: false
        },
        removePlugins: ['Title', 'ImageCaption'],
        simpleUpload: {
          uploadUrl: process.env.VUE_APP_API_URL + "filesminio/uploadCK",
          headers: {
            'Authorization': 'optional_token'
          },
        },
      },
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}filesminio/upload`,
        acceptedFiles: ".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.xls,.xlsx, .zip",
        thumbnailHeight: 100,
        thumbnailWidth: 300,
        maxFiles: 30,
        maxFilesize: 50,
        maxFileSizeInMB: 50,
        headers: { "My-Awesome-Header": "header value" },
        addRemoveLinks: true
      },
      image: "",
      file: "",
      listMenu: [],
      isTieuDe: false,
      isMoTa: false,
      isTrichYeu: false,
      isKyHieu: false,
      isNgayXuatBan: false,
      isAnhDaiDien: false,
      isNgayKy: false,
      isNoiDung: false,
      isTepTin: false,
      isShowTieuDe: false,
      isShowMoTa: false,
      isShowTrichYeu: false,
      isShowKyHieu: false,
      isShowNgayXuatBan: false,
      isShowAnhDaiDien: false,
      isShowNgayKy: false,
      isShowNoiDung: false,
      isShowTepTin: false,
      urlFile: `${process.env.VUE_APP_API_URL}filesminio/view`
    };
  },
  validations() {
    return {
      modelContent: this.rules,
    }
  },
  computed: {
    rules() {
      return {
        name: this.isTieuDe ? { required } : this.isTieuDe,
        noiDung: this.isNoiDung ? { required } : this.isNoiDung,
        moTa: this.isMoTa ? { required } : this.isMoTa,
        trichYeu: this.isTrichYeu ? { required } : this.isTrichYeu,
        ngayXuatBan: this.isNgayXuatBan ? { required } : this.isNgayXuatBan,
        ngayKy: this.isNgayKy ? { required } : this.isNgayKy,
        soKiHieu: this.isKyHieu ? { required } : this.isKyHieu,
        menu: { required },
        fileImage: this.isAnhDaiDien ? { required } : this.isAnhDaiDien
      }
    }
  },
  async created() {
    await this.GetTreeList();
    this.handleUpdateData();
  },
  methods: {
    onAccept(file) {
      this.image = file.name;
      this.file = file;
    },
    RemoveTree(node, instanceId) {
      let value = this.modelContent.menu?.find(x => x.id == node.id);
      if (value != null) {
        this.modelContent.menu = this.modelContent.menu.filter(x => x.id != value.id);
      }
    },
    AddTree(node, instanceId) {
      let index = this.modelContent.menu?.findIndex(x => x.id == node.id);
      if (index == -1 || index == undefined) {
        if (!this.modelContent.menu) {
          this.modelContent.menu = [];
        }
        this.modelContent.menu.push(node);
        this.isShowTieuDe = !this.isShowTieuDe ? node.isShowTieuDe : this.isShowTieuDe;
        this.isShowMoTa = !this.isShowMoTa ? node.isShowMoTa : this.isShowMoTa;
        this.isShowTrichYeu = !this.isShowTrichYeu ? node.isShowTrichYeu : this.isShowTrichYeu;
        this.isShowKyHieu = !this.isShowKyHieu ? node.isShowKyHieu : this.isShowKyHieu;
        this.isShowNgayXuatBan = !this.isShowNgayXuatBan ? node.isShowNgayXuatBan : this.isShowNgayXuatBan;
        this.isShowAnhDaiDien = !this.isShowAnhDaiDien ? node.isShowAnhDaiDien : this.isShowAnhDaiDien;
        this.isShowNgayKy = !this.isShowNgayKy ? node.isShowNgayKy : this.isShowNgayKy;
        this.isShowNoiDung = !this.isShowNoiDung ? node.isShowNoiDung : this.isShowNoiDung;
        this.isShowTepTin = !this.isShowTepTin ? node.isShowTepTin : this.isShowTepTin;
        this.isTieuDe = !this.isTieuDe ? node.isTieuDe : this.isTieuDe;
        this.isMoTa = !this.isMoTa ? node.isMoTa : this.isMoTa;
        this.isTrichYeu = !this.isTrichYeu ? node.isTrichYeu : this.isTrichYeu;
        this.isKyHieu = !this.isKyHieu ? node.isKyHieu : this.isKyHieu;
        this.isNgayXuatBan = !this.isNgayXuatBan ? node.isNgayXuatBan : this.isNgayXuatBan;
        this.isAnhDaiDien = !this.isAnhDaiDien ? node.isAnhDaiDien : this.isAnhDaiDien;
        this.isNgayKy = !this.isNgayKy ? node.isNgayKy : this.isNgayKy;
        this.isNoiDung = !this.isNoiDung ? node.isNoiDung : this.isNoiDung;
        this.isTepTin = !this.isTepTin ? node.isTepTin : this.isTepTin;
      }
    },
    normalizer(node) {
      if (node.children == null || node.children == 'null') {
        delete node.children;
      }
    },
    async GetTreeList() {
      await this.$store.dispatch("menuStore/getTreeListNoiBo").then((res) => {
        this.treeView = res.data;
      })
    },
    async handleUpdateData() {
      await this.$store.dispatch("contentNoiBoStore/getById", { _id: this.$route.params.id }).then((res) => {
        if (res.code === 0) {
          this.modelContent = contentNoiBoModel.fromJson(res.data);
          if (this.modelContent.menu && this.modelContent.menu.length > 0) {
            let tempMenu = [...this.modelContent.menu];
            this.modelContent.menu = [];
            tempMenu.forEach(item => {
              let node = this.findNodeInTree(this.treeView, item.id);
              if (node) {
                this.AddTree(node);
              } else {
                this.modelContent.menu.push(item);
              }
            });
          }
        } else {
          this.$store.dispatch("snackBarStore/addNotify", {
            message: res.message,
            code: res.code,
          });
        }
      });
    },
    findNodeInTree(tree, id) {
      for (let i = 0; i < tree.length; i++) {
        if (tree[i].id === id) return tree[i];
        if (tree[i].children) {
          let found = this.findNodeInTree(tree[i].children, id);
          if (found) return found;
        }
      }
      return null;
    },
    async handleSubmit(e) {
      e.preventDefault();
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
        await this.$store.dispatch("contentNoiBoStore/update", contentNoiBoModel.toJson(this.modelContent)).then((res) => {
          if (res.code === 0) {
            if (this.$refs != null && this.$refs.myVueDropzone != null) {
              this.$refs.myVueDropzone.removeAllFiles();
            }
            this.$router.push('/tin-noi-bo');
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
        });
        loader.hide();
        this.submitted = false;
      }
    },
    uploadFile(files, response) {
      let fileSuccess = response.data;
      if (response.code == 0) {
        if (!this.modelContent.files) this.modelContent.files = [];
        this.modelContent.files.push({
          fileId: fileSuccess.fileId,
          fileName: fileSuccess.fileName,
          ext: fileSuccess.ext,
          path: fileSuccess.path
        });
      }
    },
    removeThisFile(files, error, xhr) {
      let fileCongViec = JSON.parse(files.xhr.response);
      if (fileCongViec.data && fileCongViec.data.fileId) {
        let idFile = fileCongViec.data.fileId;
        if (this.modelContent.files) {
          let resultData = this.modelContent.files.filter(x => {
            return x.fileId != idFile;
          })
          this.modelContent.files = resultData;
        }
      }
    },
    sendingEvent(files, xhr, formData) {
      formData.append("files", files);
    },
    async upload() {
      if (this.modelContent != null && this.modelContent.fileImage != null) {
        axios.post(`${process.env.VUE_APP_API_URL}filesminio/delete/${this.modelContent.fileImage.fileId}`).then((response) => {
          this.modelContent.fileImage = null;
        }).catch((error) => {
          console.error('Error deleting file:', error);
        });
      }
      if (event.target && event.target.files.length > 0) {
        const formData = new FormData()
        formData.append('files', event.target.files[0])
        axios.post(`${process.env.VUE_APP_API_URL}filesminio/UploadFileImage`, formData).then((response) => {
          let resultData = response.data
          if (response.data.code == 0) {
            this.modelContent.fileImage = {
              fileId: resultData.data.fileId,
              fileName: resultData.data.fileName,
              ext: resultData.data.ext,
              path: resultData.data.path
            };
          }
        }).catch((error) => {
          console.error('Error deleting file:', error);
        });
      }
    },
    getColorWithExtFile(ext) {
      if (ext == '.docx' || ext == '.doc') return 'text-primary';
      else if (ext == '.xlsx' || ext == '.xls') return 'text-success';
      else if (ext == '.pdf') return 'text-danger';
      else return 'text-danger';
    },
    getIconWithExtFile(ext) {
      if (ext == '.docx' || ext == '.doc') return 'mdi mdi-microsoft-word';
      else if (ext == '.xlsx' || ext == '.xls') return 'mdi mdi-microsoft-excel';
      else if (ext == '.pdf') return 'mdi mdi-file-pdf-outline';
      else if (ext == '.pptx') return 'fas fa-file-powerpoint';
      else return 'mdi-file-clock-outline';
    },
    deleteImage() {
      if (this.modelContent != null && this.modelContent.fileImage != null) {
        axios.post(`${process.env.VUE_APP_API_URL}filesminio/delete/${this.modelContent.fileImage.fileId}`).then((response) => {
          this.modelContent.fileImage = null;
        }).catch((error) => {
          console.error('Error deleting file:', error);
        });
      }
    },
    deleteFile(id) {
      if (this.modelContent.files) {
        let resultData = this.modelContent.files.filter(x => {
          return x.fileId != id;
        })
        this.modelContent.files = resultData;
      }
      axios.post(`${process.env.VUE_APP_API_URL}filesminio/delete/` + id).then((response) => {
      }).catch((error) => {
        console.error('Error deleting file:', error);
      });
    },
    hasPermission(action) {
      const currentMenuId = this.$route.params.id || localStorage.getItem("currentMenuId");
      const currentUser = localStorage.getItem("auth-user");
      if (!currentUser) return false;
      try {
        const user = JSON.parse(currentUser);
        if (!user || !user.listAction || !Array.isArray(user.listAction)) return false;

        return user.listAction.some((permission) => {
          const parts = permission.split("-");
          const act = parts[0];
          const menuId = parts[parts.length - 1];

          const isActionMatch = act === action || act === "manage" || (action === "detail" && (act === "update" || act === "create"));
          const isMenuMatch = !currentMenuId || menuId === currentMenuId;

          return isActionMatch && isMenuMatch;
        });
      } catch (e) {
        return false;
      }
    },
  },
  watch: {
    'modelContent.menu': {
      deep: true,
      handler(val) {
        if (this.modelContent.menu && this.modelContent.menu.length == 0) {
          this.isTieuDe = false,
            this.isMoTa = false,
            this.isTrichYeu = false,
            this.isKyHieu = false,
            this.isNgayXuatBan = false,
            this.isAnhDaiDien = false,
            this.isNgayKy = false,
            this.isNoiDung = false,
            this.isTepTin = false,
            this.isShowMoTa = false,
            this.isShowTrichYeu = false,
            this.isShowKyHieu = false,
            this.isShowNgayXuatBan = false,
            this.isShowAnhDaiDien = false,
            this.isShowNgayKy = false,
            this.isShowNoiDung = false,
            this.isShowTepTin = false,
            this.isShowTieuDe = false
        }
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card">
      <div class="card-body">
        <form @submit.prevent="handleSubmit" ref="formContainer">
          <div class="row" ref="formContainer">
            <div class="content-lis col-md-6">
              <div class="cs-title-box">
                <div class="cs-title py-2" style="padding: 10px;">
                  <span class="fw-normal font-size-13">THÔNG TIN BÀI VIẾT</span>
                </div>
              </div>
            </div>

            <div class="text-end mt-2 col-md-6">
              <b-button
                type="submit" variant="success" class="ms-1 px-3 btn-luu">
                Cập nhật bài viết
              </b-button>
            </div>
            <div class="col-12">
              <div class="mb-2">
                <label class="text-left mb-0">Chuyên mục tin</label>
                <span style="color: red">&nbsp;*</span>
                <treeselect v-model="modelContent.menu" v-on:select="AddTree" v-on:deselect="RemoveTree"
                  :normalizer="normalizer" :options="treeView" :searchable="true" :multiple="true" :flat="true"
                  value-format="object" placeholder="Chọn chuyên mục tin"
                  :class="{ 'is-invalid': submitted && $v.modelContent.menu.$error, }">
                  <label slot="option-label"
                    slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
                    :class="labelClassName">
                    {{ node.label }}
                    <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                  </label>
                </treeselect>
                <div v-if="submitted && !$v.modelContent.menu.required" class="invalid-feedback">
                  Chuyên mục tin không được trống.
                </div>
              </div>
            </div>
            <div class="col-12" v-if="isShowTieuDe == true">
              <div class="mb-2">
                <label class="text-left mb-0">Tiêu đề bài viết</label>
                <span style="color: red" v-if="isTieuDe == true">&nbsp;*</span>
                <input v-model="modelContent.name" id="percent" type="text" class="form-control"
                  placeholder="Nhập tiêu đề bài viết" :class="{
                    'is-invalid':
                      submitted && $v.modelContent.name != null && $v.modelContent.name.$error,
                  }" />
                <div v-if="submitted && $v.modelContent.name != null && !$v.modelContent.name.required"
                  class="invalid-feedback">
                  Tiêu đề không được trống.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-check form-switch mb-2">
                <label class="text-left mb-2">Xuất bản</label>
                <input v-model="modelContent.isPublic" class="form-check-input" type="checkbox"
                  id="flexSwitchCheckChecked" checked="" />
              </div>
            </div>
            <div class="row" v-if="isShowMoTa == true">
              <div class="col-md-8">
                <div class="mb-2 ">
                  <label class="text-left mb-0">Mô tả</label>
                  <span style="color: red" v-if="isMoTa == true">&nbsp;*</span>
                  <textarea v-model="modelContent.moTa" id="percent" type="text" class="form-control mota"
                    placeholder="Nhập mô tả" :class="{
                      'is-invalid':
                        submitted && $v.modelContent.moTa != null && $v.modelContent.moTa.$error,
                    }">
                  </textarea>
                  <div v-if="submitted && $v.modelContent.moTa != null && !$v.modelContent.moTa.required"
                    class="invalid-feedback">
                    Mô tả không được trống.
                  </div>
                </div>
              </div>
              <div class="col-md-4" v-if="isShowNgayXuatBan == true">

                <div class="col-12">
                  <div class="mb-2 ">
                    <label class="text-left mb-0">Ngày xuất bản</label>
                    <span style="color: red" v-if="isNgayXuatBan == true">&nbsp;*</span>
                    <date-picker v-model="modelContent.ngayXuatBan" format="DD/MM/YYYY" id="percent"
                      placeholder="Nhập ngày xuất bản" :class="{
                        'is-invalid':
                          submitted && $v.modelContent.ngayXuatBan != null && $v.modelContent.ngayXuatBan.$error,
                      }">
                    </date-picker>
                    <div
                      v-if="submitted && $v.modelContent.ngayXuatBan != null && !$v.modelContent.ngayXuatBan.required"
                      class="invalid-feedback">
                      Ngày xuất bản không được trống.
                    </div>
                  </div>
                </div>
                <div class="col-12" v-if="isShowAnhDaiDien == true">
                  <div class="mb-2 ">
                    <label for="formFileSm" class="text-left mb-0">Ảnh đại diện</label>
                    <span style="color: red" v-if="isAnhDaiDien">&nbsp;*</span>
                    <input id="formFileSm" name="file-input" ref="fileInput" type="file" class="form-control"
                      @change="upload($event)" :class="{
                        'is-invalid':
                          submitted && $v.modelContent.fileImage != null && $v.modelContent.fileImage.$error,
                      }" />
                    <div v-if="submitted && $v.modelContent.fileImage != null && !$v.modelContent.fileImage.required"
                      class="invalid-feedback">
                      Ảnh đại diện không được trống.
                    </div>
                  </div>
                  <template v-if="modelContent.fileImage">
                    <a class="ml-25" :href="`${urlFile}/${modelContent.fileImage.fileId}`">
                      <i
                        :class="`${getColorWithExtFile(modelContent.fileImage.ext)} me-2 ${getIconWithExtFile(modelContent.fileImage.ext)}`"></i>
                      {{ modelContent.fileImage.fileName }}
                    </a>
                    <b-button variant="flat-danger" class="btn-icon" @click="deleteImage()">
                      <i class="mdi mdi-trash-can-outline"></i>
                    </b-button>
                  </template>
                </div>
              </div>

            </div>
            <div class="row" v-if="isShowTrichYeu == true">
              <div class="col-md-8">
                <div class="mb-2 ">
                  <label class="text-left mb-0">Trích yếu</label>
                  <span style="color: red" v-if="isTrichYeu">&nbsp;*</span>
                  <textarea v-model="modelContent.trichYeu" id="percent" type="text" class="form-control mota"
                    placeholder="Nhập trích yếu" :class="{
                      'is-invalid':
                        submitted && $v.modelContent.trichYeu != null && $v.modelContent.trichYeu.$error,
                    }">
      </textarea>
                  <div v-if="submitted && $v.modelContent.trichYeu != null && !$v.modelContent.trichYeu.required"
                    class="invalid-feedback">
                    Trích yếu không được trống.
                  </div>
                </div>

              </div>
              <div class="col-md-4" v-if="isShowKyHieu == true">
                <div class="col-12">
                  <div class="mb-2 ">
                    <label class="text-left mb-0">Số ký hiệu</label>
                    <span style="color: red" v-if="isKyHieu">&nbsp;*</span>
                    <input v-model="modelContent.soKiHieu" id="percent" type="text" class="form-control"
                      placeholder="Nhập số ký hiệu" :class="{
                        'is-invalid':
                          submitted && $v.modelContent.soKiHieu != null && $v.modelContent.soKiHieu.$error,
                      }" />
                    <div v-if="submitted && $v.modelContent.soKiHieu != null && !$v.modelContent.soKiHieu.required"
                      class="invalid-feedback">
                      Số kí hiệu không được trống.
                    </div>
                  </div>

                </div>
                <div class="col-12" v-if="isShowNgayKy == true">
                  <div class="mb-2 ">
                    <label class="text-left mb-0">Ngày ký</label>
                    <span style="color: red" v-if="isNgayKy == true">&nbsp;*</span>
                    <date-picker v-model="modelContent.ngayKy" format="DD/MM/YYYY" id="percent"
                      placeholder="Nhập ngày ký" :class="{
                        'is-invalid':
                          submitted && $v.modelContent.ngayKy != null && $v.modelContent.ngayKy.$error,
                      }">
                    </date-picker>
                    <div v-if="submitted && $v.modelContent.ngayKy != null && !$v.modelContent.ngayKy.required"
                      class="invalid-feedback">
                      Ngày ký không được trống.
                    </div>
                  </div>
                </div>

              </div>

            </div>

            <div class="content-lis col-10" v-if="isShowNoiDung == true">
              <div class="cs-title-box">
                <div class="cs-title py-2">
                  <span class="fw-normal font-size-13">NỘI DUNG BÀI VIẾT</span>
                </div>
              </div>
            </div>
            <div v-if="isShowNoiDung == true">
              <ckeditor-nuxt v-model="modelContent.noiDung" :config="editorConfig" :class="{
                'is-invalid':
                  submitted && $v.modelContent.noiDung != null && $v.modelContent.noiDung.$error,
              }">

              </ckeditor-nuxt>
              <div v-if="submitted && $v.modelContent.noiDung != null && !$v.modelContent.noiDung.required"
                class="invalid-feedback">
                Nội dung bài viết không được trống.
              </div>
            </div>

            <template v-if="modelContent.files && modelContent.files.length > 0">
              <div v-for="(file, index) in modelContent.files" :key="index">
                <a class="ml-25" :href="`${urlFile}/${file.fileId}`">
                  <i :class="`${getColorWithExtFile(file.ext)} me-2 ${getIconWithExtFile(file.ext)}`"></i>{{
                  file.fileName }}
                </a>
                <b-button variant="flat-danger" class="btn-icon" @click="deleteFile(file.fileId)">
                  <i class="mdi mdi-trash-can-outline"></i>
                </b-button>
              </div>
            </template>

            <template v-if="isShowTepTin == true">
              <div style="margin-top: 20px;">
                <vue-dropzone id="dropzone" ref="myVueDropzone" :use-custom-slot="true" :options="dropzoneOptions"
                  v-on:vdropzone-sending="sendingEvent" v-on:vdropzone-removed-file="removeThisFile"
                  v-on:vdropzone-success="uploadFile">
                  <div class="dropzone-custom-content">
                    <div class="mb-1">
                      <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                    </div>
                    <h4>Kéo thả tệp hoặc click vào đây để tải tệp tin.</h4>
                  </div>
                </vue-dropzone>
              </div>
            </template>

          </div>
        </form>
      </div>
    </div>

  </Layout>
</template>
<style>
.hidden-sortable:after,
.hidden-sortable:before {
  display: none !important;
}

.vue-treeselect__menu {
  max-height: 165px !important;
}

.btn-luu {
  background-color: #05912a;
  border: none;
}

.btn-luu:hover {
  background-color: #05912a;
}

.mx-table .mx-table-date .table thead th,
thead,
th {
  background-color: rgb(255, 255, 255) !important;
  accent-color: #0e0e0e !important;
  border: none;
}

.mota {
  height: 100px;
}

.mx-calendar-content .cell.active {
  color: #fff;
  background-color: #1284e7 !important;
}

.page-content {
  min-height: 800px;
}
</style>
